export default "__VITE_ASSET__LO3_ru19__"